"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface InvsmtTailoringQuestionsProps {
  onBack?: () => void;
}

const QUESTIONS: TailoringQuestion[] = [
  { 
    id: "inv-1", 
    question: "Have any investments been reclassified during the year from non-current to current or vice versa?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "inv-2", 
    question: "Have any current investments been revalued at period-end in accordance with \"AS-13 Accounting for Investments\"?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "inv-3", 
    question: "Have any investments been purchased/sold in the current year?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "inv-4", 
    question: "Has there been any other than temporary decline in the value of non-current investments?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
];

export default function InvsmtTailoringQuestions({ onBack }: InvsmtTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Investments"
      title="Investments - Tailoring Questions"
      description="Answer the following."
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}



